import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../helpers/export'
import Service from './Service'

const screen = SCREEN.FILING_STATUS

export const getHighlight = createAsyncThunk(
  'companyAnalysis/filingStatus/getHighlight',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getHighlight(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const getOverdueTaxDebt = createAsyncThunk(
  'companyAnalysis/filingStatus/getOverdueTaxDebt',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await Service.getOverdueTaxDebt(params)
      if (response.success) {
        const overdueValues = response.data?.overdueTaxDebtHistory || []
        const invoiceValues = response.data?.invoiceEnforcementHistory || []
        const getValues = () =>
          [...overdueValues, ...invoiceValues].map((item) => ({
            value: item?.totalValue,
            year: new Date(item?.publicDateId).getFullYear(),
          }))
        dispatch(calculateDefaultUnit({ screen, getValues }))
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const getOverdueSocialInsurance = createAsyncThunk(
  'companyAnalysis/filingStatus/getOverdueSocialInsurance',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await Service.getOverdueSocialInsurance(params)
      if (response.success) {
        const getValues = () =>
          response.data.map((item) => ({
            value: item.totalValue,
            year: new Date(item?.publicDateId).getFullYear(),
          }))
        dispatch(calculateDefaultUnit({ screen, getValues }))
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const exportOverdueTaxDebt = createAsyncThunk(
  'companyAnalysis/filingStatus/exportOverdueTaxDebt',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.exportOverdueTaxDebt(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportOverdueSocialInsurance = createAsyncThunk(
  'companyAnalysis/filingStatus/exportOverdueSocialInsurance',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.exportOverdueSocialInsurance(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)
